import { createRouter, RouterProvider } from '@tanstack/react-router';
import { routeTree } from '../routeTree.gen';

/**
 * Forge router — TanStack Router file-based routing.
 *
 * The `routeTree` is generated by `@tanstack/router-vite-plugin` from the
 * files under `src/routes/`. The generated file (`src/routeTree.gen.ts`) is
 * gitignored — it's produced on `vite dev`/`vite build` and never edited
 * by hand.
 */
const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function AppRouterProvider() {
  return <RouterProvider router={router} />;
}
